"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerApi = exports.PartnerApiFactory = exports.PartnerApiFp = exports.PartnerApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * PartnerApi - axios parameter creator
 * @export
 */
const PartnerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode, acceptLanguage }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getBrandingPartnerConfig', 'uniqCode', uniqCode);
            const localVarPath = `/v1/partners/codes/{uniq_code}/config`.replace(`{${'uniq_code'}}`, encodeURIComponent(String(uniqCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/codes/{uniq_code}/config`,
                sdkMethod: 'getBrandingPartnerConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/circles/configs/unsponsored`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/configs/unsponsored`,
                sdkMethod: 'getCircleUnsponsoredConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, countryCode, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerDependentGroupConfigByCountryCode', 'partnerId', partnerId);
            // verify required parameter 'countryCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerDependentGroupConfigByCountryCode', 'countryCode', countryCode);
            const localVarPath = `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${'country_code'}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`,
                sdkMethod: 'getPartnerDependentGroupConfigByCountryCode',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, email, firstName, lastName, dob, subscriberId, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerMemberAsAdmin', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/members/search`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] =
                    dob instanceof Date
                        ? dob.toISOString().substr(0, 10)
                        : dob;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/members/search`,
                sdkMethod: 'getPartnerMemberAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigById', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/config`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/config`,
                sdkMethod: 'getPartnersConfigById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigByUniqCodeAsAdmin', 'uniqCode', uniqCode);
            const localVarPath = `/v1/partners/codes/{uniq_code}`.replace(`{${'uniq_code'}}`, encodeURIComponent(String(uniqCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/codes/{uniq_code}`,
                sdkMethod: 'getPartnersConfigByUniqCodeAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PartnerApiAxiosParamCreator = PartnerApiAxiosParamCreator;
/**
 * PartnerApi - functional programming interface
 * @export
 */
const PartnerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PartnerApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandingPartnerConfig(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleUnsponsoredConfig(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerDependentGroupConfigByCountryCode(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerMemberAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigByUniqCodeAsAdmin(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PartnerApiFp = PartnerApiFp;
/**
 * PartnerApi - factory interface
 * @export
 */
const PartnerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PartnerApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig(params, options) {
            return localVarFp
                .getBrandingPartnerConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return localVarFp
                .getCircleUnsponsoredConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode(params, options) {
            return localVarFp
                .getPartnerDependentGroupConfigByCountryCode(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return localVarFp
                .getPartnerMemberAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById(params, options) {
            return localVarFp
                .getPartnersConfigById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return localVarFp
                .getPartnersConfigByUniqCodeAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.PartnerApiFactory = PartnerApiFactory;
/**
 * PartnerApi - object-oriented interface
 * @export
 * @class PartnerApi
 * @extends {BaseAPI}
 */
class PartnerApi extends base_1.BaseAPI {
    /**
     * URL `/v1/partners/codes/{uniq_code}/config`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns Partners config by partner id
     * @param {string} uniqCode Partner Unique Code
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getBrandingPartnerConfig(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getBrandingPartnerConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/configs/unsponsored`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get unsponsored config
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getCircleUnsponsoredConfig(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getCircleUnsponsoredConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`
     *
     * @summary Returns Partner Dependent Group config by partner id and dependent group ID
     * @param {string} partnerId The ID of the partner
     * @param {string} countryCode The country code of the dependent group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getPartnerDependentGroupConfigByCountryCode(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnerDependentGroupConfigByCountryCode(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/members/search`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
     * @summary Gets Partners Member as admin by partner id and search criteria.
     * @param {string} partnerId The ID of the partner
     * @param {string} [memberId] Id of the member to search
     * @param {string} [email] Email of the member to search
     * @param {string} [firstName] First name of the member to search
     * @param {string} [lastName] Last name of the member to search
     * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
     * @param {string} [subscriberId] SubscriberId of the member to search.
     * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getPartnerMemberAsAdmin(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnerMemberAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/config`
     *
     * @summary Returns Partners config by partner id
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getPartnersConfigById(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnersConfigById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/codes/{uniq_code}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
     * @summary Returns Partners config as admin by uniq code
     * @param {string} uniqCode Partner Unique Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    getPartnersConfigByUniqCodeAsAdmin(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnersConfigByUniqCodeAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnerApi = PartnerApi;
//# sourceMappingURL=partner-api.js.map